import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Row, Col } from 'react-bootstrap';

const propTypes = {
  settings: PropTypes.instanceOf(Map).isRequired,
};

function NoEvents({ settings, image }) {
  if (image) {
    return <img src={image} alt="No listing" width="100%" />;
  }
  return (
    <Row>
      <Col xs={12} className="no-events">
        {settings.get('noEventsText')}
      </Col>
    </Row>
  );
}

NoEvents.propTypes = propTypes;

export default NoEvents;
